const ONDE_USAR_AUTH = 'Basic UG9ydGFsQ2xpZW50OndmNWRQeWZ4OHZPUGZabA==';
const ONDE_USAR_AUTH_SCOPE = 'Portal.veloe';
const ONDE_USAR_AUTH_URL = 'https://api.veloe.com.br/auth/v1/authentication/token';

const ONDE_USAR_LIST_AUTH = 'Basic UG9ydGFsQ2xpZW50OndmNWRQeWZ4OHZPUGZabA==';
const ONDE_USAR_LIST_URL = 'https://api.veloe.com.br/api/graphql';


//https://stackoverflow.com/questions/1502590/calculate-distance-between-two-points-in-google-maps-v3
const rad = function(x) {
  return x * Math.PI / 180;
};

let CACHED_TOKEN = null;
const invalidateToken = () => {
  CACHED_TOKEN = null;
}

const getDistance = (p1, p2) => {
  if (!p1 || !p2 || !p1.latitude || !p2.latitude) return ""
  const R = 6378137; // Earth’s mean radius in meter
  const dLat = rad(p2.latitude - p1.latitude);
  const dLong = rad(p2.longitude - p1.longitude);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.latitude)) * Math.cos(rad(p2.latitude)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  const distance = Math.max(0,d/1000)
  if (isNaN(distance)){
      return ""
  }
  return `${distance.toPrecision(3)}`
};

export const getAuth = async () => {

    if (CACHED_TOKEN){
      return CACHED_TOKEN
    }

    if (!ONDE_USAR_AUTH || !ONDE_USAR_AUTH_SCOPE || !ONDE_USAR_AUTH_URL){
        console.log("missing required env vars",[ONDE_USAR_AUTH, ONDE_USAR_AUTH_SCOPE,ONDE_USAR_AUTH_URL])
        return;
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", ONDE_USAR_AUTH);

    var urlencoded = new URLSearchParams();
    urlencoded.append("grant_type", "client_credentials");
    urlencoded.append("scope", `${ONDE_USAR_AUTH_SCOPE}`);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };

    try {
        const response = await fetch(ONDE_USAR_AUTH_URL, requestOptions)
        const body = await response.text()
        const json = JSON.parse(body)
        if (!!json && json.access_token){
            CACHED_TOKEN = json;
            const refreshToken = parseInt(Number.isFinite(json.expires_in) ? json.expires_in / 2 : (3600 /2)) //30min default
            setTimeout(invalidateToken,(parseInt(refreshToken) || 1) * 1000)
            return json;
        }
    }catch(err) {
        return null;
    }
}

export const fetchData = async (
    token,
    text,
    latlong,
    category = '',
    geolocation,
    limit = 999
  ) => {
    if (!ONDE_USAR_LIST_AUTH || !ONDE_USAR_LIST_URL) {
      console.log('missing required env vars', [
        ONDE_USAR_LIST_AUTH,
        ONDE_USAR_LIST_URL,
      ])
      return null
    }
  
    const myHeaders = new Headers()
    myHeaders.append('Authorization', ONDE_USAR_LIST_AUTH)
    myHeaders.append('token', token)
    myHeaders.append('Content-Type', 'application/json')
  
    const required = { text, limit, category }
    const vars =
      latlong && geolocation
        ? {
            latitude: latlong.latitude,
            longitude: latlong.longitude,
            ...required,
          }
        : required
  
    const graphql = JSON.stringify({
      query: `query (
          $latitude: Float,
          $longitude: Float,
          $category: String,
          $text: String = "",
          $limit: Int = 5,
          $filters: [SearchFilter]
        ) {
          establishments: searchEstablishmentWithTextSearch(
            latitude: $latitude,
            longitude: $longitude,
            category: $category,
            text: $text,
            limit: $limit,
            filters: $filters
          ) {
            id
            areaId
            name
            address { street, number, city, state }
            category
            brand { iconUrl }
            location { latitude, longitude }
            workingHours { is24Hrs, opensAt, closesAt }
          }
        }`,
      variables: vars,
    })
  
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: graphql,
      redirect: 'follow',
    }
  
    try {
      const response = await fetch(ONDE_USAR_LIST_URL, requestOptions)
      const body = await response.text()
      const json = JSON.parse(body)
      if (!!json && json.data && json.data.establishments) {
        let result = json.data.establishments
        result = result
          .map((item) => {
            item.latlong = latlong
            item.distance = getDistance(latlong, item.location) || 0
            return item
          })
          .sort((a, b) => (a.distance > b.distance ? 1 : -1))
          .filter(
            (item) =>
              !!(item.category || '').match(
                /CONCESSIONARIA|ESTACIONAMENTO|ABASTECIMENTO/i
              )
          )
        return result
      }
    } catch (err) {
      console.warn(err)
    }
    return null
  }

